import { Pipe, PipeTransform } from '@angular/core'
import { globalConst } from '../constant/constant'

import { DomSanitizer } from '@angular/platform-browser'

/*
 * 为了不使html去掉其中的style 样式
 */
@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html): any {
    const content = html ? html : ''
    return this.sanitizer.bypassSecurityTrustHtml(content)
  }
}
//  取 globalConst 常量值
function globalConstPipe(value, key, defaultValues?) {
  let label = ''
  globalConst[key].forEach((element) => {
    if (element.value === value) {
      label = element.label
    }
  })
  return label || defaultValues || value
}

// 人民币、货币格式化
// {{123456789.123456789 | money}} ---> 123,456,789.12
// {{123456789.123456789 | money:'￥':'元'}} ---> ￥123,456,789.12元
// {{123456789.123456789 | money:'人民币':'万元'}} ---> 人民币123,456,789.12万元
@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (!value) return '0.00'
    if(typeof(value) == 'string'){
      value = Number(value)
    }
    value = value.toFixed(2)
    var intPart = Math.trunc(value) // 获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    var floatPart = '.00' // 预定义小数部分
    var value2Array = value.split('.')
    // =2表示数据有小数位
    if (value2Array.length === 2) {
      floatPart = value2Array[1].toString() // 拿到小数部分
      if (floatPart.length === 1) {
        return (args[0] || '') + intPartFormat + '.' + floatPart + '0' + (args[1] || '')
      } else {
        return (args[0] || '') + intPartFormat + '.' + floatPart + (args[1] || '')
      }
    } else {
      return (args[0] || '') + intPartFormat + floatPart + (args[1] || '')
    }
  }
}

@Pipe({
  name: 'payStatusPipe',
})
export class PayStatusPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Pay_Status', '/')
  }
}

// 账单列表开票状态  与发票列表状态不同
@Pipe({
  name: 'invoiceStatusPipe',
})
export class InvoiceStatusPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Invoice_Status', '/')
  }
}
// 报销状态
@Pipe({
  name: 'reimburseStatusPipe'
})
export class ReimburseStatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Reimburse_Status','/');
  }

}
// 发票 发票类型
@Pipe({
  name: 'invoiceTypePipe',
})
export class InvoiceTypePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Invoice_Type', '/')
  }
}

//  发票列表开票类型
@Pipe({
  name: 'invoiceReceiptTypePipe',
})
export class InvoiceReceiptTypePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Invoice_Receipt_Type', '/')
  }
}

//  发票列表状态
@Pipe({
  name: 'invoiceListStatusPipe',
})
export class InvoiceListStatusPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Invoice_List_Status', '/')
  }
}

//  账单列表发布状态
@Pipe({
  name: 'releaseStatusPipe',
})
export class ReleaseStatusPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Bill_Release_Status', '/')
  }
}

//  账单列表发布状态
@Pipe({
  name: 'payWayPipe',
})
export class PayWayPipe implements PipeTransform {
  transform(value: any, status?: any): any {
    // 状态为待支付时，直接返回/
    if(status == 0){
      return '/'
    }
    return globalConstPipe(value, 'Pay_Way', '/')
  }
}
//  消息读取状态
@Pipe({
  name: 'messageStatusPipe',
})
export class MessageStatusPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Message_Status')
  }
}
//  消息读取状态
@Pipe({
  name: 'balanceStatusPipe',
})
export class BalanceStatusPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Balance_Status')
  }
}
//  订单状态
@Pipe({
  name: 'orderStatusPipe',
})
export class OrderStatusPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return globalConstPipe(value, 'Order_Status')
  }
}